import { p as palette, c as color } from '../base/color-DMp1DFwP.js';
import { a as spacingValues, s as spacing } from '../base/spacing-zNVNrnl_.js';
import { f as focus } from '../base/focus-B_eJw-S_.js';
import { g as globals } from '../base/globals-KScgLNUm.js';

const theme = {
  isEvolutionRebrand: true,
  color,
  focusVisible: focus,
  globals,
  palette,
  spacing,
  spacingValues
};

export { theme as t };
//# sourceMappingURL=evolution-BrAsobcx.js.map
